<template>
  <div>
    <div class="mb-3">
      <b-row>
        <b-col cols="12" v-if="items.length == 0 && showData == 0">
          <b-alert variant="warning" style="font-size: 0.9rem;" show>
            <strong>ไม่มีรายการสั่งซื้อในขณะนี้</strong> รายการสั่งซื้อทั้งหมด 0
            รายการ
          </b-alert>
        </b-col>
        <b-col cols="3">
          <label for="timerange" class="pl-2">วันที่แจ้งโอน</label>
          <div class="date-range-field">
            <b-input-group>
              <b-form-input
                size="sm"
                type="text"
                :value="showRange"
                placeholder="วันที่เริ่มสั่งซื้อ - วันที่สิ้นสุดสั่งซื้อ"
                disabled
              />

              <b-input-group-append>
                <!-- Open Calendar Button -->
                <b-button size="sm" variant="primary" @click="toggleCalendar">
                  <b-icon icon="calendar-range"></b-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>

            <!-- Relative Wrapper for Popup Calendar & Footer Button -->
            <div v-if="isCalendarOpen" class="date-picker-wrapper">
              <DatePicker
                id="calendar-range"
                v-model="range"
                locale="th"
                is-range
                @input="handleRangeChange"
              />

              <!-- Bottom Center Cancel / Clear Button -->
              <div class="calendar-footer">
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="cancel-btn"
                  @click="clearAndCloseCalendar"
                >
                  ยกเลิก
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="3">
          <label for="studentFirstName" class="pl-2"> ชื่อผู้เรียน </label>
          <b-input-group class="pt-1 pl-2">
            <b-form-input
              id="studentFirstName"
              size="sm"
              type="text"
              v-model="studentFirstName"
              placeholder="ค้นหาชื่อผู้เรียน"
            />
          </b-input-group>
        </b-col>
        <b-col cols="3">
          <label for="studentLastName" class="pl-2"> นามสกุลผู้เรียน </label>
          <b-input-group class="pt-1 pl-2">
            <b-form-input
              id="studentLastName"
              size="sm"
              type="text"
              v-model="studentLastName"
              placeholder="ค้นหานามสกุลผู้เรียน"
            />
          </b-input-group>
        </b-col>
        <b-col cols="3" v-show="comId == 519">
          <label for="corperateName" class="pl-2"> ชื่อบริษัท </label>
          <b-input-group class="pt-1 pl-2">
            <b-form-input
              id="corperateName"
              size="sm"
              type="text"
              v-model="corperateName"
              placeholder="ค้นหาชื่อบริษัท"
            />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-col cols="3">
          <label for="studentEmail" class="pl-2"> อีเมล </label>
          <b-input-group class="pt-1 pl-2">
            <b-form-input
              id="studentEmail"
              size="sm"
              type="text"
              v-model="studentEmail"
              placeholder="ค้นหาอีเมล"
            />
          </b-input-group>
        </b-col>
        <b-col cols="3">
          <label for="invoiceNumber" class="pl-2"> เลขใบแจ้งหนี้ </label>
          <b-input-group class="pt-1 pl-2">
            <b-form-input
              id="invoiceNumber"
              size="sm"
              type="text"
              v-model="invoiceNumber"
              placeholder="เลขใบแจ้งหนี้"
            />
          </b-input-group>
        </b-col>
        <b-col cols="3">
          <label for="paidName" class="pl-2"> สถานะรายการสั่งซื้อ </label>
          <b-dropdown right size="sm" variant="ligth" no-caret class="p-0">
            <template #button-content class="p-0">
              <b-input-group>
                <b-form-input
                  id="paidName"
                  size="sm"
                  class="input-dropdown"
                  :value="paidName"
                >
                </b-form-input>
                <b-input-group-append>
                  <i class="icon-dropdown" aria-hidden="true">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-funnel"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"
                      />
                    </svg>
                  </i>
                </b-input-group-append>
              </b-input-group>
            </template>
            <b-dropdown-item @click="getPaidStatus('all')">
              รายการทั้งหมด
            </b-dropdown-item>
            <b-dropdown-item @click="getPaidStatus('success')">
              รายการที่ชำระเงินแล้ว
            </b-dropdown-item>
            <b-dropdown-item @click="getPaidStatus('failed')">
              รายการที่ยังไม่ชำระเงิน
            </b-dropdown-item>
            <b-dropdown-item @click="getPaidStatus('cancel')">
              รายการที่ยกเลิก
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col cols="3" v-show="comId == 519">
          <label for="idNo" class="pl-2"> เลขประจำตัวผู้เสียภาษี </label>
          <b-input-group class="pt-1 pl-2">
            <b-form-input
              id="idNo"
              size="sm"
              type="text"
              v-model="idNo"
              placeholder="ค้นหาเลขประจำตัวผู้เสียภาษี"
            />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-input-group class="pt-1 pl-4">
          <b-button size="sm" variant="primary" @click="getSearchKeyword()">
            ค้นหา
          </b-button>
        </b-input-group>
      </b-row>
    </div>
    <hr />
    <b-row class="mt-4">
      <b-col cols="7" v-if="items.length > 0 || showData == 1">
        <span style="font-size: 14px; margin-right: 10px;">
          <strong>รายการสั่งซื้อทั้งหมด {{ items.length }} รายการ</strong>
        </span>
        <b-button
          class="inputDate"
          size="sm"
          variant="success"
          style="font-size: 12px;"
        >
          ชำระเงินแล้ว {{ getPurchaseSuccess(items) }} รายการ
        </b-button>
      </b-col>
      <b-col cols="5" v-if="items.length > 0 || showData == 1">
        <CancelOrderReportPDF
          v-if="
            paidStatus === 'cancel' &&
              (comId === 1000001 || comId === 1000002 || comId === 1000003)
          "
          :selectedMonth="fetchParams.selectedMonth"
          :start="fetchParams.startDate"
          :end="fetchParams.endDate"
          :studentFirstName="fetchParams.studentFirstName"
          :studentLastName="fetchParams.studentLastName"
          :studentEmail="fetchParams.studentEmail"
          :invoiceNumber="fetchParams.invoiceNumber"
          :btnDisabled="false"
          :status="cStatus"
          @no-data="handleNoData"
        ></CancelOrderReportPDF>
        <b-button
          v-else
          @click="exportExcel()"
          size="sm"
          variant="info"
          style="float: right;"
        >
          <b-icon icon="chevron-double-down" />
          ดาวน์โหลดรายงาน
          <b-spinner
            id="export-excel-loading"
            style="display: none"
            small
          ></b-spinner>
        </b-button>
        <ag-grid-vue
          style="width: 100%; height: 100%; display: none"
          class="ag-theme-alpine"
          :columnDefs="columnDefs"
          @grid-ready="onGridReady"
          :excelStyles="
            comId == 513 && isReportFlowAccData
              ? excelFlowAccStyles
              : excelDefStyles
          "
          :rowData="reportData"
        >
        </ag-grid-vue>
        <b-button
          hidden
          v-if="comId == 513"
          @click="exportExcelFlowAcc()"
          size="sm"
          variant="outline-info"
          style="float: right; margin-right: 4px;"
        >
          <b-icon icon="chevron-double-down" />
          ดาวน์โหลด FLOWACC
          <b-icon icon="graph-up" />
          <b-spinner
            id="export-excel-flow-acc-loading"
            style="display: none"
            small
          ></b-spinner>
        </b-button>
      </b-col>
      <b-col cols="12" class="mt-4" v-if="isLoading">
        <Loading v-if="isLoading && showData == 0" />
      </b-col>
      <b-col cols="12" class="mt-4" v-else>
        <b-table
          id="course-order-list"
          :fields="fields"
          :items="items"
          :per-page="perPage"
          :current-page="currentPage"
          responsive
          style="font-size: 14px;
                 border:hidden;"
          :busy="isLoading"
          hover
          striped
          show-empty
        >
          <template slot="table-busy" class="text-center text-danger my-2">
            <Loading />
          </template>
          <template #empty>
            <p class="text-center">ไม่มีข้อมูล</p>
          </template>
          <template v-slot:cell(datetime)="data">
            {{ formatDate(data.item.co_actualPurchaseDateTime) }}<br />
            {{ formatTime(data.item.co_actualPurchaseDateTime) }}
          </template>
          <template v-slot:cell(fullname)="data">
            {{ data.item.mp_firstName }} {{ data.item.mp_lastName }}
          </template>
          <template v-slot:cell(email)="data">
            {{ data.item.m_email }}
          </template>
          <template v-slot:cell(price)="data">
            <span v-if="comId == 519">
              {{ formatPrice(data.item.btf_bahtAmount) }} บาท
            </span>
            <span v-else>
              {{ formatPrice(data.item.co_purchasePrice) }} บาท
            </span>
          </template>
          <template v-slot:cell(amount)="data">
            {{ data.item.itemCount }}
          </template>
          <template v-slot:cell(status)="data">
            <span v-if="data.item.co_cancelFlag == 1" class="text-danger">
              <strong>ยกเลิก</strong>
            </span>
            <span v-else-if="data.item.co_paidFlag == 0" class="text-secondary">
              <strong>ยังไม่ชำระเงิน</strong>
            </span>
            <span v-else-if="data.item.co_paidFlag == 1">
              <strong class="text-success">ชำระเงินแล้ว</strong>
              <br />
              <strong v-if="formatPrice(data.item.co_purchasePrice) <= 0"
                >ฟรี</strong
              >
              <strong v-else>
                {{ getPaymentMethod(data.item) }}
              </strong>
            </span>
          </template>
          <template #cell(action)="row">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="row.toggleDetails"
              class="mr-2"
            >
              ดูข้อมูล
            </b-button>
          </template>
          <template v-slot:row-details="rowData">
            <b-row>
              <b-col>
                <table
                  class="borderless-table"
                  style="border-collapse: collapse; border: none;"
                >
                  <tr
                    v-if="
                      comId == 1000001 || comId == 1000002 || comId == 1000003
                    "
                  >
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>รหัสชำระเงิน (ref2) :</b></td>
                    <td>
                      {{ rowData.item.co_orderNumber }}
                    </td>
                    <td class="text-right">
                      <b-button
                        class="btn-action"
                        size="sm"
                        variant="light"
                        :href="
                          `${company.whitelabelUrl}/invoice/paymentInvoice?orderId=${rowData.item.co_orderId}`
                        "
                        target="_blank"
                      >
                        ใบแจ้งหนี้
                      </b-button>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>ชื่อผู้แจ้งโอน</b></td>
                    <td>
                      {{ rowData.item.mp_firstName }}
                      {{ rowData.item.mp_lastName }}
                    </td>
                    <td v-if="comId == 519" class="text-right">
                      <b-button
                        class="btn-action"
                        size="sm"
                        variant="light"
                        :href="
                          `${company.whitelabelUrl}/invoice/paymentInvoice?orderId=${rowData.item.co_orderId}`
                        "
                        target="_blank"
                      >
                        ใบแจ้งหนี้
                      </b-button>
                    </td>
                    <td
                      v-if="
                        (comId == 1000001 ||
                          comId == 1000002 ||
                          comId == 1000003) &&
                          rowData.item.co_paidFlag == 1
                      "
                      class="text-right"
                    >
                      <b-button
                        v-if="rowData.item.co_paidFlag == 1"
                        class="btn-action"
                        size="sm"
                        variant="light"
                        :href="
                          `${company.whitelabelUrl}/invoice/paymentReceipt?orderId=${rowData.item.co_orderId}`
                        "
                        target="_blank"
                      >
                        ใบเสร็จรับเงิน
                      </b-button>
                    </td>
                    <td v-else-if="comId == 519" class="text-right">
                      <b-button
                        v-if="rowData.item.co_paidFlag == 1"
                        class="btn-action"
                        size="sm"
                        variant="outline-primary"
                        @click="
                          info(rowData.item, rowData.index, $event.target)
                        "
                      >
                        หลักฐานการชำระเงิน
                      </b-button>
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>เลขบัตรประชาชน</b></td>
                    <td>
                      {{ rowData.item.mp_idCard }}
                    </td>
                    <td
                      v-if="
                        comId == 1000001 || comId == 1000002 || comId == 1000003
                      "
                      class="text-right"
                    >
                      <b-button
                        v-if="rowData.item.co_paidFlag == 1"
                        class="btn-action"
                        size="sm"
                        variant="outline-primary"
                        @click="
                          info(rowData.item, rowData.index, $event.target)
                        "
                      >
                        หลักฐานการชำระเงิน
                      </b-button>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>อีเมล</b></td>
                    <td>
                      {{ rowData.item.m_email }}
                    </td>
                    <td
                      v-if="
                        (comId == 1000001 ||
                          comId == 1000002 ||
                          comId == 1000003) &&
                          rowData.item.co_cancelFlag == 0
                      "
                      class="text-right"
                    >
                      <b-button
                        v-if="rowData.item.co_paidFlag == 1"
                        class="btn-action"
                        size="sm"
                        variant="outline-danger"
                        @click="
                          refundInfo(rowData.item, rowData.index, $event.target)
                        "
                      >
                        ยกเลิก/คืนเงิน
                      </b-button>
                    </td>
                    <td
                      v-else-if="
                        (comId == 1000001 ||
                          comId == 1000002 ||
                          comId == 1000003) &&
                          rowData.item.co_cancelFlag == 1
                      "
                      class="text-right"
                    >
                      <b-button
                        v-if="rowData.item.co_cancelFlag == 1"
                        class="btn-action"
                        size="sm"
                        variant="light"
                        @click="
                          cancelInfo(rowData.item, rowData.index, $event.target)
                        "
                      >
                        ประวัติการสั่งซื้อ
                      </b-button>
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>โทรศัพท์</b></td>
                    <td>
                      {{ rowData.item.mp_mobilePhone }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>ช่องทางการชำระเงิน</b></td>
                    <td v-if="formatPrice(rowData.item.co_purchasePrice) <= 0">
                      ฟรี
                    </td>
                    <td v-else>
                      {{ getPaymentMethod(rowData.item) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>จำนวนเงินที่โอน</b></td>
                    <td>
                      {{ formatPrice(rowData.item.btf_bahtAmount) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr v-if="comId == 519">
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>อีเมลสำหรับจัดส่ง E-TAX</b></td>
                    <td style="max-width: 300px;">
                      {{ rowData.item.co_etaxRecipient }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>รหัสคูปอง</b></td>
                    <td>
                      {{ rowData.item.pc_code ?? "-" }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>โปรโมชั่น</b></td>
                    <td>
                      {{
                        rowData.item.tcd_name ?? rowData.item.ccd_name ?? "-"
                      }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="width: 9%;"></td>
                    <td style="width: 29%;"><b>หมายเหตุ</b></td>
                    <td>
                      {{ rowData.item.co_remark ?? "-" }}
                    </td>
                    <td></td>
                  </tr>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <table class="custom-table" v-if="comId == 519">
                  <thead>
                    <tr>
                      <th style="width:80%">รายการ</th>
                      <th class="text-right">ราคา</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody id="item-data">
                    <tr
                      v-for="(item, index) in rowData.item.items"
                      :key="index"
                    >
                      <td>{{ item.c_name }}</td>
                      <td class="text-right">
                        {{ formatPrice(Number(item.coi_price) / 1.07) }}
                      </td>
                      <td></td>
                    </tr>
                    <tr v-if="rowData.item.co_discountValue > 0">
                      <td>ส่วนลด</td>
                      <td class="text-right">
                        -
                        {{
                          formatPrice(
                            Number(rowData.item.co_discountValue) / 1.07,
                          )
                        }}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>ภาษีมูลค่าเพิ่ม 7%</td>
                      <td class="text-right">
                        {{
                          formatPrice(
                            calculateVat(
                              rowData.item.co_discountValue,
                              rowData.item.items,
                            ),
                          )
                        }}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>ยอดรวม</td>
                      <td class="text-right">
                        {{
                          formatPrice(
                            rowData.item.co_totalPrice -
                              rowData.item.co_discountValue,
                          )
                        }}
                      </td>
                      <td class="bath">บาท</td>
                    </tr>
                    <tr>
                      <td>หักภาษี ณ ที่จ่าย 3%</td>
                      <td class="text-right">
                        {{
                          rowData.item.co_withHoldingTaxValue == "0.00"
                            ? "0.00"
                            : "-" +
                              formatPrice(rowData.item.co_withHoldingTaxValue)
                        }}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>ยอดชำระจริง</td>
                      <td class="text-right">
                        {{
                          formatPrice(
                            rowData.item.co_purchasePrice -
                              rowData.item.co_withHoldingTaxValue,
                          )
                        }}
                      </td>
                      <td class="bath">บาท</td>
                    </tr>
                  </tbody>
                </table>
                <table v-else>
                  <thead>
                    <tr>
                      <th style="width:90%">รายการ</th>
                      <th>ราคา</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in rowData.item.items"
                      :key="index"
                    >
                      <td>{{ item.c_name }}</td>
                      <td class="text-right">
                        {{ formatPrice(item.coi_price) }}
                      </td>
                      <td></td>
                    </tr>
                    <tr v-if="rowData.item.co_discountValue > 0">
                      <td>ส่วนลด</td>
                      <td class="text-right">
                        -{{
                          formatPrice(Math.abs(rowData.item.co_discountValue))
                        }}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><strong>ยอดรวม</strong></td>
                      <td class="text-right">
                        <strong>{{
                          formatPrice(
                            rowData.item.co_totalPrice -
                              rowData.item.co_discountValue,
                          )
                        }}</strong>
                      </td>
                      <td class="bath"><strong>บาท</strong></td>
                    </tr>
                    <tr v-if="rowData.item.co_shippingFee">
                      <td><strong>ค่าขนส่ง</strong></td>
                      <td class="text-right">
                        <strong>{{
                          formatPrice(rowData.item.co_shippingFee)
                        }}</strong>
                      </td>
                      <td class="bath"><strong>บาท</strong></td>
                    </tr>
                    <tr>
                      <td><strong>ยอดชำระจริง</strong></td>
                      <td class="text-right">
                        <strong>{{
                          formatPrice(rowData.item.co_purchasePrice)
                        }}</strong>
                      </td>
                      <td class="bath"><strong>บาท</strong></td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </template>
        </b-table>

        <!-- modal -->
        <b-modal
          :id="infoModal.id"
          centered
          size="md"
          hide-footer
          @hide="resetInfoModal"
        >
          <template #modal-title>
            <h6 style="font-weight: 600;">หลักฐานการชำระเงิน</h6>
          </template>
          <template #default>
            <b-row>
              <b-col cols="3">
                <h6 style="font-weight: 600;">วันที่</h6>
              </b-col>
              <b-col>
                <h6>
                  {{ infoModal.content.co_actualPurchaseDateTime }}
                </h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <h6 style="font-weight: 600;">ชื่อผู้เรียน</h6>
              </b-col>
              <b-col>
                <h6>
                  {{ infoModal.content.mp_firstName }}
                  {{ infoModal.content.mp_lastName }}
                </h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <h6 style="font-weight: 600;">ราคา</h6>
              </b-col>
              <b-col>
                <h6 v-if="comId == 519">
                  {{
                    formatPrice(Number(infoModal.content.co_totalPrice) / 1.07)
                  }}
                  บาท
                </h6>
                <h6 v-else>
                  {{ formatPrice(infoModal.content.co_purchasePrice) }} บาท
                </h6>
              </b-col>
            </b-row>
            <b-row v-if="comId == 519">
              <b-col cols="3">
                <h6 style="font-weight: 600;">ยอดชำระจริง</h6>
              </b-col>
              <b-col>
                <h6>
                  {{
                    formatPrice(
                      infoModal.content.co_purchasePrice -
                        infoModal.content.co_withHoldingTaxValue,
                    )
                  }}
                  บาท
                </h6>
              </b-col>
            </b-row>
            <template v-if="slipImageSrc">
              <b-row>
                <b-col
                  cols="12"
                  style="text-align: center; margin: 20px 0 20px"
                >
                  <img
                    :src="slipImageSrc"
                    alt="Payment Slip"
                    style="width: 100%;"
                  />
                </b-col>
              </b-row>
            </template>
          </template>
        </b-modal>

        <!-- refund modal -->
        <b-modal
          :id="refundModal.id"
          centered
          size="lg"
          hide-footer
          @hide="resetRefundModal"
        >
          <template #modal-title>
            <h6 style="font-weight: 600;">สาเหตุการยกเลิก</h6>
          </template>
          <template #default>
            <b-row>
              <b-col cols="3">
                <h6 style="font-weight: 600;">วันที่</h6>
              </b-col>
              <b-col>
                <h6>
                  {{ refundModal.content.co_actualPurchaseDateTime }}
                </h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <h6 style="font-weight: 600;">ชื่อผู้เรียน</h6>
              </b-col>
              <b-col>
                <h6>
                  {{ refundModal.content.mp_firstName }}
                  {{ refundModal.content.mp_lastName }}
                </h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <h6 style="font-weight: 600;">ราคา</h6>
              </b-col>
              <b-col>
                <h6 v-if="comId == 519">
                  {{
                    formatPrice(
                      Number(refundModal.content.co_totalPrice) / 1.07,
                    )
                  }}
                  บาท
                </h6>
                <h6 v-else>
                  {{ formatPrice(refundModal.content.co_purchasePrice) }} บาท
                </h6>
              </b-col>
            </b-row>
            <b-form-group label="สาเหตุ" class="mb-3">
              <b-form-select
                v-model="refundForm.reason"
                :options="reasonOptions"
              ></b-form-select>
            </b-form-group>
            <b-form-group label="รายละเอียดการยกเลิก" class="mb-4">
              <b-form-textarea
                v-model="refundForm.description"
                rows="3"
                placeholder="กรอกรายละเอียด..."
              ></b-form-textarea>
            </b-form-group>
            <div class="text-right">
              <b-button
                variant="secondary"
                class="mr-2"
                @click="$bvModal.hide(refundModal.id)"
              >
                ย้อนกลับ
              </b-button>

              <b-button variant="danger" @click="submitRefund">
                ยกเลิกรายการ
              </b-button>
            </div>
          </template>
        </b-modal>

        <!-- cancel modal -->
        <b-modal
          :id="cancelModal.id"
          centered
          size="xl"
          hide-footer
          @hide="resetCancelModal"
        >
          <template #modal-title>
            <h6 style="font-weight: 600;">
              ประวัติรายการสั่งซื้อคอร์สเรียนของ
              {{ cancelModal.content?.paid?.by || "" }}
            </h6>
          </template>
          <template #default>
            <b-row class="font-weight-bold border-bottom pb-2 mb-2">
              <b-col cols="2">วันที่ทำรายการ</b-col>
              <b-col cols="2">รหัสชำระเงิน (ref2)</b-col>
              <b-col cols="2">สถานะรายการ</b-col>
              <b-col cols="2">ทำรายการโดย</b-col>
              <b-col cols="2">สาเหตุการยกเลิก</b-col>
              <b-col cols="2">รายละเอียดการยกเลิก</b-col>
            </b-row>
            <!-- ยกเลิก -->
            <b-row
              v-if="
                cancelModal.content.canceled &&
                  !cancelModal.content.refund.reason
              "
              class="py-2 border-bottom"
            >
              <b-col cols="2">
                {{ cancelModal.content.canceled.dateTime }}
              </b-col>

              <b-col cols="2">
                {{ cancelModal.content.canceled?.orderNumber }}
              </b-col>

              <b-col cols="2" class="text-danger">
                ยกเลิก
              </b-col>

              <b-col cols="2">
                ระบบ
              </b-col>

              <b-col cols="2">
                เกินกำหนดชำระเงิน
              </b-col>

              <b-col cols="2">
                เกินกำหนดรับชำระเงิน จึงถูกยกเลิกโดยระบบ
              </b-col>
            </b-row>
            <!-- คืนเงิน -->
            <b-row
              v-if="
                cancelModal.content.refund && cancelModal.content.refund.reason
              "
              class="py-2 border-bottom"
            >
              <b-col cols="2">
                {{ cancelModal.content.refund.dateTime }}
              </b-col>

              <b-col cols="2">
                {{ cancelModal.content.refund.orderNumber }}
              </b-col>

              <b-col cols="2" class="text-danger">
                ยกเลิก
              </b-col>

              <b-col cols="2">
                {{ cancelModal.content.refund.by }}
              </b-col>

              <b-col cols="2">
                {{ cancelModal.content.refund.reason }}
              </b-col>

              <b-col cols="2">
                {{ cancelModal.content.refund.description }}
              </b-col>
            </b-row>

            <!-- ชำระเงิน -->
            <b-row v-if="cancelModal.content.paid" class="py-2 border-bottom">
              <b-col cols="2">
                {{ cancelModal.content.paid.dateTime }}
              </b-col>

              <b-col cols="2">
                {{ cancelModal.content.paid.orderNumber }}
              </b-col>

              <b-col cols="2" class="text-success">
                ชำระเงินแล้ว
              </b-col>

              <b-col cols="2">
                {{ cancelModal.content.paid.by }}
              </b-col>

              <b-col cols="2"></b-col>
              <b-col cols="2"></b-col>
            </b-row>
          </template>
        </b-modal>
      </b-col>
    </b-row>
    <b-row class="mt-3" v-if="items.length > 0 || showData == 1">
      <b-col cols="6">
        <form class="form-inline">
          <div class="form-group mb-2">
            <label>แสดง</label>
          </div>
          <div class="form-group ml-2 mb-2">
            <b-form-select
              v-model="selectedShow"
              size="sm"
              @change="changeShowData"
            >
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="50">50</option>
            </b-form-select>
          </div>
          <div class="form-group ml-2 mb-2">
            <label>
              จาก
              {{ items.length }}
              รายการ
            </label>
          </div>
        </form>
      </b-col>
      <b-col cols="6" v-if="items.length > 0 || showData == 1">
        <nav class="float-right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="items.length"
            aria-controls="course-order-list"
            last-number
          >
          </b-pagination>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/services/api.js";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import Numeral from "numeral";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import Loading from "@/components/shared/Loading";
import CancelOrderReportPDF from "@/components/reports/cancel-order/CancelOrderReportPDF";

// import SearchBox from "../../../shared/SearchBox";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    DatePicker,
    "ag-grid-vue": AgGridVue,
    Loading,
    CancelOrderReportPDF,
    // SearchBox,
  },
  data() {
    return {
      refundForm: {
        reason: null,
        description: "",
      },
      reasonOptions: [
        { value: null, text: "เลือกสาเหตุ" },
        { value: "ย้ายไปเรียนคอร์สอื่น", text: "ย้ายไปเรียนคอร์สอื่น" },
        { value: "ขอคืนเงิน", text: "ขอคืนเงิน" },
        {
          value: "ขอยกเลิกรายการ ที่ไม่ได้ซื้อผ่าน Payment Service Provider",
          text: "ขอยกเลิกรายการ ที่ไม่ได้ซื้อผ่าน Payment Service Provider",
        },
      ],
      comId: this.$store.state.Company.companyInfo.id,
      company: {},
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      refundModal: {
        id: "refund-modal",
        title: "",
        content: "",
      },
      cancelModal: {
        id: "cancel-modal",
        title: "",
        content: "",
      },
      slipImageSrc: null,
      items: [],
      fields: [
        {
          label: "วันที่",
          key: "datetime",
          sortable: true,
        },
        {
          label: "ชื่อผู้เรียน",
          key: "fullname",
        },
        {
          label: "อีเมล",
          key: "email",
        },
        {
          label: "ราคา",
          key: "price",
        },
        {
          label: "จำนวนคอร์ส",
          key: "amount",
        },
        {
          label: "สถานะ",
          key: "status",
        },
        {
          label: "",
          key: "action",
        },
      ],
      showData: 0,
      paidName: "รายการทั้งหมด",
      isLoading: false,
      range: {
        start: "",
        end: "",
      },
      isCalendarOpen: false,
      fetchParams: {
        selectedMonth: "",
        startDate: "",
        endDate: "",
        courseName: "",
        studentFirstName: "",
        studentLastName: "",
        studentEmail: "",
        invoiceNumber: "",
        paid: "",
        corperateName: "",
        idNo: "",
      },
      courseName: "",
      studentFirstName: "",
      studentLastName: "",
      studentEmail: "",
      invoiceNumber: "",
      corperateName: "",
      idNo: "",
      selectedShow: 10,
      perPage: 10,
      currentPage: 1,
      columnDefs: [
        {
          headerName: "No.",
          field: "rowIndex",
          width: 80,
          pinned: "left",
          cellClass: "text-center",
        },
        {
          headerName: "No.Order",
          field: "orderNumber",
          cellClass: "text-center",
        },
        {
          headerName: "ชื่อ นามสกุล (ผู้เข้าอบรม)",
          field: "studentFullName",
          cellClass: "text-left",
        },
        {
          headerName: "ชื่อในใบกำกับ",
          field: "invoiceName",
          cellClass: "text-left",
        },
        {
          headerName: "ที่อยู่1",
          field: "address1",
          cellClass: "text-left",
        },
        {
          headerName: "ที่อยู่2",
          field: "address2",
          cellClass: "text-left",
        },
        {
          headerName: "เบอร์โทร",
          field: "Phone",
          cellClass: "text-left",
        },
        { headerName: "TAX ID", field: "taxId", cellClass: "text-center" },
        {
          headerName: "สนญ / สาขาที่",
          field: "branch",
          cellClass: "text-center",
        },
        {
          headerName: "สถานะ",
          field: "status",
          cellClass: "text-center",
        },
        { headerName: "ชื่อหลักสูตร", field: "" },

        {
          headerName: "รวม-สูตร",
          field: "totalAmount",
          cellClass: "text-right",
        },
        {
          headerName: "ส่วนลด",
          field: "discount",
          cellClass: "text-right",
        },
        {
          headerName: "ยอดเงิน",
          field: "netTotal",
          cellClass: "text-right",
        },
        {
          headerName: "VAT",
          field: "vat",
          cellClass: "text-right",
        },
        {
          headerName: "เงินสุทธิ",
          field: "sumTotal",
          cellClass: "text-right",
        },
        {
          headerName: "หัก ณ ที่จ่าย",
          field: "withHoldingTax",
          cellClass: "text-right",
        },
        {
          headerName: "ยอดชำระจริง",
          field: "paymentAmount",
          cellClass: "text-right",
        },
        {
          headerName: "วันที่ชำระ",
          field: "purchaseDateTime",
          cellClass: "text-center",
        },
        {
          headerName: "ธนาคาร",
          field: "bankName",
          cellClass: "text-center",
        },
        { headerName: "#", field: "", cellClass: "text-left" },
        { headerName: "หมายเหตุ", field: "remark", cellClass: "text-left" },
        { headerName: "#", field: "", cellClass: "text-left" },
        { headerName: "คูปอง", field: "coupon", cellClass: "text-left" },
        {
          headerName: "โปรโมชั่น",
          field: "promotion",
          cellClass: "text-left",
        },
        {
          headerName: "ชื่อผู้รับใบเสร็จ",
          field: "billingName",
          cellClass: "text-left",
        },
        {
          headerName: "ที่อยู่จัดส่งใบเสร็จ1",
          field: "billingAddress1",
          cellClass: "text-left",
        },
        {
          headerName: "ที่อยู่จัดส่งใบเสร็จ2",
          field: "billingAddress2",
          cellClass: "text-left",
        },
        {
          headerName: "เบอร์โทรผู้รับใบเสร็จ",
          field: "billingPhone",
          cellClass: "text-left",
        },
        { headerName: "#", field: "" },
      ].filter(Boolean),
      reportData: null,
      gridApi: null,
      excelDefStyles: [
        {
          id: "header",
          font: { fontName: "Cordia New", size: 16, bold: true },
          alignment: {
            horizontal: "Center",
          },
        },
        {
          id: "text-center",
          font: { fontName: "Cordia New", size: 16 },
          alignment: {
            horizontal: "Center",
          },
          dataType: "String",
        },
        {
          id: "text-right",
          font: { fontName: "Cordia New", size: 16 },
          alignment: {
            horizontal: "Right",
          },
          dataType: "String",
        },
        {
          id: "text-left",
          font: { fontName: "Cordia New", size: 16 },
          alignment: {
            horizontal: "left",
          },
          dataType: "String",
        },
      ],
    };
  },
  async mounted() {
    this.isLoading = true;
    await api.get(
      `v1/members-role-permission/${this.$store.state.Authentication.authUser.id}`,
    );
    await this.setDefaultRange(this.comId);
    await this.fetchPurchase();
    this.setCompanyInfo();
    this.isLoading = false;
  },
  computed: {
    ...mapGetters("CourseOrder", [
      "courseOrderListByOrder",
      "isLoading",
      "courseOrderListFlowAcc",
      "courseTransferOrderDetails",
      "orderRefundDetails",
    ]),
    showRange() {
      return this.getFormattedRange(
        this.range.start,
        this.range.end,
        "calendar-range",
      );
    },
    formatStartDate() {
      if (this.range.start != "") {
        return moment(this.range.start).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    formatEndDate() {
      if (this.range.end != "") {
        return moment(this.range.end).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapActions("CourseOrder", [
      "fetchCourseOrderListByOrder",
      "fetchCourseOrderListFlowAcc",
      "getCourseTransferOrderDetails",
      "refundOrder",
      "getOrderRefundDetails",
    ]),
    isTutorrusCompany() {
      if (localStorage.getItem("ComId") == 408) {
        return true;
      } else {
        return false;
      }
    },
    async fetchPurchase() {
      this.fetchParams.selectedMonth = moment().format("YYYY-MM");
      this.fetchParams.startDate =
        this.range?.start == ""
          ? ""
          : moment(this.range.start).format("YYYY-MM-DD");
      this.fetchParams.endDate =
        this.range?.end == ""
          ? ""
          : moment(this.range.end).format("YYYY-MM-DD");
      this.fetchParams.courseName = this.courseName;
      this.fetchParams.studentFirstName = this.studentFirstName;
      this.fetchParams.studentLastName = this.studentLastName;
      this.fetchParams.studentEmail = this.studentEmail;
      this.fetchParams.invoiceNumber = this.invoiceNumber;
      this.fetchParams.paid = this.paidStatus;
      this.fetchParams.corperateName = this.corperateName;
      this.fetchParams.idNo = this.idNo;
      await this.fetchCourseOrderListByOrder(this.fetchParams);
      this.items = this.courseOrderListByOrder;
    },
    getPurchaseSuccess(item) {
      let paymentSuccess = 0;
      for (let i = 0; i < item.length; i++) {
        if (item[i].co_paidFlag == 1 && item[i].co_cancelFlag != 1) {
          paymentSuccess = paymentSuccess + 1;
        }
      }
      return paymentSuccess;
    },
    setPaidName(status) {
      if (status == "all") {
        this.paidName = "รายการทั้งหมด";
      } else if (status == "success") {
        this.paidName = "รายการที่ชำระเงินแล้ว";
      } else if (status == "failed") {
        this.paidName = "รายการที่ยังไม่ชำระเงิน";
      } else if (status == "cancel") {
        this.paidName = "รายการที่ยกเลิก";
      }
    },
    async exportExcel() {
      document.getElementById("export-excel-loading").style.display =
        "inline-block";
      await this.fetchPurchase();

      let subItem = this.items.map((element) => element.items);
      let maxLengthArray = subItem.reduce(
        (max, array) => (array.length > max.length ? array : max),
        [],
      );

      let courseItemColumns = this.prepareCourseItemColumns(maxLengthArray);
      let isWannasorn = [1000001, 1000002, 1000003].includes(this.comId);
      // insert course items columns into column#10
      let exportColumnDefs = [...this.columnDefs];

      const courseIdx = exportColumnDefs.findIndex(
        (c) => c.headerName === "ชื่อหลักสูตร",
      );

      exportColumnDefs.splice(courseIdx, 1, ...courseItemColumns);

      if (this.comId == 519) {
        let emailField = [
          {
            headerName: "อีเมล",
            field: "email",
            cellClass: "text-center",
          },
          {
            headerName: "E-TAX",
            field: "etax",
            cellClass: "text-center",
          },
        ];

        const taxIdx = exportColumnDefs.findIndex((c) => c.field === "taxId");

        exportColumnDefs.splice(taxIdx, 0, ...emailField);
      } else if (isWannasorn) {
        let shippingCostFields = [
          {
            headerName: "ค่าส่ง",
            field: "shippingCost",
            cellClass: "text-center",
          },
        ];

        let discountIdx = exportColumnDefs.findIndex(
          (c) => c.headerName === "ส่วนลด",
        );

        exportColumnDefs.splice(discountIdx, 0, ...shippingCostFields);
      }

      let summaryRow = this.calculateSummaryRow();
      // merge order data with summary row
      this.reportData = [...this.prepareReportData(summaryRow), summaryRow];

      this.gridApi.setColumnDefs(exportColumnDefs);

      setTimeout(() => {
        this.gridApi.exportDataAsExcel({
          sheetName: "course-order-list-by-order",
          fileName: `CourseOrderListByOrder`,
        });
        document.getElementById("export-excel-loading").style.display = "none";
        this.gridApi.setColumnDefs(this.columnDefs);
      }, 1000);
    },
    async onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    prepareCourseItemColumns(maxLengthArray) {
      let resultColumn = [];
      maxLengthArray.forEach((item, index) => {
        let newColumn = [];
        newColumn.push(
          {
            headerName: `ชื่อหลักสูตร ${index + 1}`,
            field: `courseName_${index + 1}`,
            cellClass: "text-left",
          },
          {
            headerName: "คน",
            field: `people_${index + 1}`,
            cellClass: "text-center",
          },
          {
            headerName: "ราคา",
            colId: `priceCol_${index + 1}`,
            field: "ราคา",
            cellClass: "text-right",
            valueGetter: (params) => {
              let pricePropertyName = `price_${index + 1}`;
              if (params.data[pricePropertyName] == -1) {
                return "";
              }
              if (params.data[pricePropertyName]) {
                if (this.comId == 519) {
                  return this.formatPrice(
                    params.data[pricePropertyName] / 1.07,
                  );
                } else {
                  return params.data[pricePropertyName];
                }
              } else {
                return "";
              }
            },
          },
          {
            field: "จำนวนเงิน",
            colId: `amountCol_${index + 1}`,
            cellClass: "text-right",
            valueGetter: (params) => {
              let pricePropertyName = `price_${index + 1}`;
              if (params.data[pricePropertyName] == -1) {
                return "";
              }
              if (params.data[pricePropertyName]) {
                if (this.comId == 519) {
                  return this.formatPrice(
                    params.data[pricePropertyName] / 1.07,
                  );
                } else {
                  return params.data[pricePropertyName];
                }
              } else {
                return "0";
              }
            },
          },
        );
        resultColumn = resultColumn.concat(newColumn);
      });
      return resultColumn;
    },
    calculateSummaryRow() {
      let startDate =
        this.range.start != ""
          ? moment(this.range.start)
              .add(543, "years")
              .format("DD/MM/YYYY")
          : "";
      let endDate =
        this.range.end != ""
          ? moment(this.range.end)
              .add(543, "years")
              .format("DD/MM/YYYY")
          : "";

      let sumPuarchasePrice = null,
        sumPeople = null,
        sumtotalAmount = null,
        sumDiscount = null,
        sumVat = null,
        sumsumTotal = null,
        sumWithHolding = null,
        sumPaymentAmount = null;

      this.items.forEach((item) => {
        sumPeople = sumPeople + item.items.length;
        sumVat += Number(this.calculateVat(item.co_discountValue, item.items));
        sumsumTotal += Number(item.co_purchasePrice);
        if (this.comId == 519) {
          sumPuarchasePrice += item.co_purchasePrice / 1.07;
          sumtotalAmount += item.co_totalPrice / 1.07;
          sumDiscount += item.co_discountValue / 1.07;
          sumWithHolding += Number(item.co_withHoldingTaxValue);
          sumPaymentAmount +=
            item.co_purchasePrice - item.co_withHoldingTaxValue;
        } else {
          sumPuarchasePrice += item.co_purchasePrice;
          sumtotalAmount += item.co_totalPrice;
          sumDiscount += item.co_discountValue;
        }
      });
      let summaryRow = {
        rowIndex: startDate + " - " + endDate,
        studentFullName: this.formatPrice(sumPuarchasePrice),
        invoiceName: sumPeople,
        totalAmount: this.formatPrice(sumtotalAmount),
        discount: "-" + this.formatPrice(sumDiscount),
        netTotal: this.formatPrice(sumPuarchasePrice),
        vat: this.formatPrice(sumVat),
        sumTotal: this.formatPrice(sumsumTotal),
        withHoldingTax: this.formatPrice(sumWithHolding),
        paymentAmount: this.formatPrice(sumPaymentAmount),
        items: [{ coi_purchasePrice: -1 }],
      };
      return summaryRow;
    },
    prepareReportData(summaryRow) {
      let result = this.items.map((element, index) => {
        let flattenedC = {};
        element.items.forEach((item, index) => {
          flattenedC[`courseName_${index + 1}`] = item.c_name;
          flattenedC[`price_${index + 1}`] = Number(item.coi_price);
          flattenedC[`people_${index + 1}`] = "1";
          if (isNaN(summaryRow[`people_${index + 1}`])) {
            summaryRow[`people_${index + 1}`] = 1;
            summaryRow[`price_${index + 1}`] = -1;
          } else {
            summaryRow[`people_${index + 1}`]++;
            summaryRow[`price_${index + 1}`] = -1;
          }
        });

        const namePrefix = "คุณ";
        let studentFullName =
          namePrefix + element.mp_firstName + " " + element.mp_lastName;
        let invoiceName = "";
        if (element.mba_type == "CORPERATE") {
          invoiceName = element.mba_corperateName;
        } else if (element.mba_firstName) {
          invoiceName =
            namePrefix + element.mba_firstName + " " + element.mba_lastName;
        }

        let billingFullName = element.msa_firstName
          ? namePrefix + element.msa_firstName + " " + element.msa_lastName
          : "";

        let building = element.mba_buildingName
          ? "อาคาร " + element.mba_buildingName + " "
          : "";
        let floor = element.mba_floor ? "ชั้น " + element.mba_floor + " " : "";
        let number = element.mba_number ? element.mba_number + " " : "";
        let moo = element.mba_moo ? "ม." + element.mba_moo + " " : "";
        let village = element.mba_village
          ? "มบ." + element.mba_village + " "
          : "";
        let soi = element.mba_soi ? "ซ." + element.mba_soi + " " : "";
        let street = element.mba_street ? "ถ." + element.mba_street + " " : "";
        let subDistrict = "";
        let district = "";
        let province = "";
        if (element.mba_province == "กรุงเทพมหานคร") {
          subDistrict = element.mba_subDistrict
            ? "แขวง" + element.mba_subDistrict + " "
            : "";
          district = element.mba_district
            ? "เขต" + element.mba_district + " "
            : "";
          province = "กทม.";
        } else {
          subDistrict = element.mba_subDistrict
            ? "ต." + element.mba_subDistrict + " "
            : "";
          district = element.mba_district
            ? "อ." + element.mba_district + " "
            : "";
          province = element.mba_province
            ? "จ." + element.mba_province + " "
            : "";
        }
        let postcode = element.mba_postcode ? element.mba_postcode + " " : "";
        let branch =
          element.mba_branch == "MAIN_OFFICE"
            ? "สำนักงานใหญ่"
            : element.mba_branch == "BRANCH_OFFICE"
            ? "สาขาที่ " + element.mba_branchId
            : "-";
        let status =
          element.co_cancelFlag == 1
            ? "ยกเลิก"
            : element.co_paidFlag == 0
            ? "ยังไม่ชำระเงิน"
            : "ชำระเงินแล้ว (" +
              (this.formatPrice(element.co_purchasePrice) <= 0
                ? "ฟรี)"
                : this.getPaymentMethod(element) + ")");
        let msa_buildingName = element.msa_buildingName
          ? "อาคาร " + element.msa_buildingName + " "
          : "";
        let msa_floor = element.msa_floor
          ? "ชั้น " + element.msa_floor + " "
          : "";
        let msa_number = element.msa_number ? element.msa_number + " " : "";
        let msa_moo = element.msa_moo ? "ม." + element.msa_moo + " " : "";
        let msa_village = element.msa_village
          ? "มบ." + element.msa_village + " "
          : "";
        let msa_soi = element.msa_soi ? "ซ." + element.msa_soi + " " : "";
        let msa_street = element.msa_street
          ? "ถ." + element.msa_street + " "
          : "";
        let msa_subDistrict = "";
        let msa_district = "";
        let msa_province = "";
        if (element.msa_province == "กรุงเทพมหานคร") {
          msa_subDistrict = element.msa_subDistrict
            ? "แขวง" + element.msa_subDistrict + " "
            : "";
          msa_district = element.msa_district
            ? "เขต" + element.msa_district + " "
            : "";
          msa_province = "กทม.";
        } else {
          msa_subDistrict = element.msa_subDistrict
            ? "ต." + element.msa_subDistrict + " "
            : "";
          msa_district = element.msa_district
            ? "อ." + element.msa_district + " "
            : "";
          msa_province = element.msa_province
            ? "จ." + element.msa_province + " "
            : "";
        }
        let msa_postcode = element.msa_postcode
          ? element.msa_postcode + " "
          : "";

        let totalAmount = null;
        let discount = null;
        let netTotal = null;
        let withHoldingTax = null;
        let paymentAmount = null;
        if (this.comId == 519) {
          totalAmount = this.formatPrice(element.co_totalPrice / 1.07);
          discount =
            "-(" + this.formatPrice(element.co_discountValue / 1.07) + ")";
          netTotal = this.formatPrice(element.co_purchasePrice / 1.07);
          withHoldingTax = element.co_withHoldingTaxValue;
          paymentAmount = this.formatPrice(
            element.co_purchasePrice - element.co_withHoldingTaxValue,
          );
        } else {
          totalAmount = element.co_totalPrice;
          discount = "-(" + (element.co_discountValue ?? "0.00") + ")";
          netTotal = element.co_purchasePrice;
          withHoldingTax = null;
          paymentAmount = null;
        }

        return {
          rowIndex: index + 1,
          orderNumber: element.co_orderNumber,
          studentFullName: studentFullName,
          invoiceName: invoiceName,
          address1:
            number +
            building +
            floor +
            village +
            moo +
            soi +
            street +
            subDistrict,
          address2: district + province + postcode,
          Phone: element.mp_mobilePhone,
          email: element.m_email,
          etax: element.co_etaxRecipient ?? "-",
          taxId: element.mba_idNo,
          branch: branch,
          status: status,
          totalAmount: totalAmount,
          discount: discount,
          shippingCost: element.co_shippingFee ?? "0.00",
          netTotal: netTotal,
          vat: this.formatPrice(
            this.calculateVat(element.co_discountValue, element.items),
          ),
          sumTotal: element.co_purchasePrice,
          withHoldingTax: withHoldingTax,
          paymentAmount: paymentAmount,
          purchaseDateTime: this.formattedDate(
            element.co_actualPurchaseDateTime,
          ),
          bankName:
            element.cpa_BTBankName == "QRPROMPTPAY"
              ? "QR code"
              : element.cpa_BTBankName,
          remark: element.co_remark,
          coupon: element.pc_code,
          promotion: element.tcd_name ?? element.ccd_name,
          billingName: billingFullName,
          billingAddress1:
            msa_number +
            msa_buildingName +
            msa_floor +
            msa_village +
            msa_moo +
            msa_soi +
            msa_street +
            msa_subDistrict,
          billingAddress2: msa_district + msa_province + msa_postcode,
          billingPhone: element.msa_phone,
          items: element.items,
          ...flattenedC,
        };
      });
      return result;
    },
    setCompanyInfo() {
      this.company = { ...this.$store.state.Company.companyInfo };
    },
    formatDate(datetime) {
      return moment(datetime).format("YYYY-MM-DD");
    },
    formatTime(datetime) {
      return moment(datetime).format("HH:mm:ss");
    },
    formatPrice(price) {
      return Numeral(price).format("0,0.00");
    },
    async getSearchKeyword() {
      this.isLoading = true;
      await this.fetchPurchase();
      this.currentPage = 1; // Reset to first page when new search is applied
      if (this.items.length > 0) {
        this.showData = 0;
      } else {
        this.showData = 1;
      }
      this.isLoading = false;
    },
    async getPaidStatus(status) {
      this.isLoading = true;
      this.paidStatus = status;
      await this.fetchPurchase();
      if (this.items.length > 0) {
        this.showData = 0;
        this.setPaidName(this.paidStatus);
      } else {
        this.showData = 1;
        this.setPaidName(this.paidStatus);
      }
      this.isLoading = false;
    },
    setDefaultRange(id) {
      if ([1000001, 1000002, 1000003].includes(id)) {
        this.range = { start: new Date(), end: new Date() };
        return;
      }

      const now = new Date();
      const firstDayOfThisMonth = new Date(
        now.getFullYear(),
        now.getMonth(),
        1,
      );
      const lastDayOfThisMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        0,
      );

      this.range = { start: firstDayOfThisMonth, end: lastDayOfThisMonth };
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    async showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
        this.showData = 1;
        await this.fetchPurchase();
        if (this.items.length > 0) {
          this.showData = 0;
        }
        this.isLoading = false;
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    toggleCalendar() {
      this.isCalendarOpen = !this.isCalendarOpen;
    },
    handleRangeChange(newRange) {
      if (newRange && newRange.start && newRange.end) {
        this.isCalendarOpen = false; // Close calendar automatically after range selection
      }
    },
    clearAndCloseCalendar() {
      this.range.start = "";
      this.range.end = "";
      this.isCalendarOpen = false; // Hide calendar popup
      this.applyCalendarRange();
    },
    async applyCalendarRange() {
      this.isLoading = true;
      this.showData = 1;
      try {
        await this.fetchPurchase();
      } finally {
        if (this.items.length > 0) {
          this.showData = 0;
        }
        this.isLoading = false;
      }
    },
    changeShowData() {
      this.perPage = this.selectedShow;
    },
    async info(item, index, button) {
      await this.getCourseTransferOrderDetails(item.co_orderId).then(() => {});
      this.infoModal.content = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
      this.slipImageSrc = this.courseTransferOrderDetails.paymentSlip.replace(
        "open?",
        "thumbnail?",
      );
      if (this.slipImageSrc) {
        this.slipImageSrc += "&sz=w1000";
      }
    },
    async refundInfo(item, index, button) {
      await this.getCourseTransferOrderDetails(item.co_orderId).then(() => {});
      this.refundModal.content = item;
      this.$root.$emit("bv::show::modal", this.refundModal.id, button);
    },

    async cancelInfo(item, index, button) {
      await this.getOrderRefundDetails(item.co_orderId).then((data) => {
        return data;
      });
      this.cancelModal.content = this.orderRefundDetails;
      this.$root.$emit("bv::show::modal", this.cancelModal.id, button);
      this.slipImageSrc = this.courseTransferOrderDetails.paymentSlip.replace(
        "open?",
        "thumbnail?",
      );
      if (this.slipImageSrc) {
        this.slipImageSrc += "&sz=w1000";
      }
    },

    resetCancelModal() {
      this.cancelModal.title = "";
      this.cancelModal.content = "";
      this.refundForm.reason = null;
      this.refundForm.description = "";
    },

    resetRefundModal() {
      this.refundModal.title = "";
      this.refundModal.content = "";
      this.refundForm.reason = null;
      this.refundForm.description = "";
    },

    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
      this.refundForm.reason = null;
      this.refundForm.description = "";
    },

    async submitRefund() {
      try {
        // validate
        if (!this.refundForm.reason) {
          this.$bvToast.toast("กรุณาเลือกสาเหตุ", {
            variant: "warning",
            solid: true,
          });
          return;
        }

        // payload
        const payload = {
          orderId: this.refundModal.content.co_orderId,
          refundReason: this.refundForm.reason,
          refundDescription: this.refundForm.description,
        };
        //API
        await this.refundOrder(payload);

        // success
        this.$bvToast.toast("ยกเลิกรายการสำเร็จ", {
          variant: "success",
          solid: true,
        });

        // modal
        this.$bvModal.hide(this.refundModal.id);

        // reset form
        this.resetRefundModal();

        // reload list
        this.fetchPurchase();
      } catch (error) {
        console.error(error);

        this.$bvToast.toast("เกิดข้อผิดพลาด", {
          variant: "danger",
          solid: true,
        });
      }
    },
    calculateVat(discount, items) {
      let sumPuarchasePriceWithVat = null;
      let sumPuarchasePriceNoVat = null;

      items.forEach((item) => {
        sumPuarchasePriceWithVat =
          sumPuarchasePriceWithVat + Number(item.coi_price);
      });
      items.forEach((item) => {
        sumPuarchasePriceNoVat =
          sumPuarchasePriceNoVat + Number(item.coi_price) / 1.07;
      });

      if (this.comId == 519) {
        return (
          sumPuarchasePriceWithVat -
          sumPuarchasePriceNoVat -
          (discount - discount / 1.07)
        );
      } else {
        return null;
      }
    },
    formattedDate(date) {
      const dateObject = new Date(date);
      const thaiYear = dateObject.getFullYear() + 543;

      const formattedDate = dateObject.toLocaleDateString("th-TH", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      const formattedDateWithThaiYear = formattedDate
        .replace(/\d{4}/, thaiYear.toString())
        .replace(/\//g, "-");

      return formattedDateWithThaiYear;
    },
    checkedTransfer(item) {
      let paymentMethod = "";

      if (item.cpa_accountType == "BANKTRANSFER") {
        paymentMethod = item.cpa_BTBankName + " " + item.cpa_BTAccountNumber;
      } else if (item.cpa_accountType == "QRTRANSFER") {
        paymentMethod = "QR code";
      } else if (item.cpa_accountType == "PROMPTPAYTRANSFER") {
        paymentMethod = "PROMPTPAY " + item.cpa_BTAccountNumber;
      } else {
        paymentMethod = "เงินโอน";
      }

      return paymentMethod;
    },
    getPaymentMethod(item) {
      switch (item.co_paymentMethod) {
        case "CASH":
          return "เงินสด";
        case "CASH_TRANSFER":
          return "ชำระผ่านสาขา";
        case "TRANSFER":
          return this.checkedTransfer(item);
        case "ONLINEBANKING":
          return "Online Banking";
        case "CREDITCARD":
          return "บัตรเครดิต";
        case "COUNTER_SERVICE":
          return "Counter service";
        case "EXTENSION":
          return "การต่ออายุ";
        case "DATAIMPORT":
          return "การนำเข้าข้อมูล";
        case "KTC_FLEXI":
          return "installment via KTC gateway";
        case "KTC_RETAIL":
          return "KTC gateway";
        case "REDEEM":
          return "แลกส่วนลด";
        case "QRCODE":
          return "QR Code";
        case "INSTALLMENT":
          return "ผ่อนชำระ";
        case "PROMOCODE":
          return "คูปอง";
        case "SCBQRCODE":
          return "SCB QR Code";
        case "UNIONPAY":
          return "UnionPay";
        default:
          return "Unknown method";
      }
    },
  },
};
</script>

<style scoped>
/* Container positioning */
.date-picker-wrapper {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 5px;
  z-index: 1000;

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding-bottom: 10px;
}

/* Override v-calendar absolute positioning so it stays inside normal document flow */
.date-picker-wrapper .vc-container {
  position: relative !important;
  right: auto !important;
  left: auto !important;
  margin-right: 0 !important;
  border: none !important; /* Removes inner calendar border so it matches wrapper */
  box-shadow: none !important;
}

/* Footer layout */
.calendar-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid #f1f5f9;
}

.calendar-footer .cancel-btn {
  font-size: 0.85rem;
  padding: 4px 16px;
  border-radius: 4px;
}

.date-range-field,
.date-field {
  .form-control:disabled {
    background-color: #fff;
  }
}

.btn-action {
  padding: 2px 6px 2px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

.text-right {
  text-align: right;
}

.bath {
  padding-left: 0;
}

.table-striped tbody tr:nth-of-type(odd),
.table-striped tbody tr:nth-of-type(even) {
  background-color: #e7f1ff;
}

.custom-table tr td,
.custom-table tr th {
  padding-top: 7px;
  padding-bottom: 7px;
}

.borderless-table tr td {
  padding-top: 7px;
  padding-bottom: 7px;
}
.p-0,
.p-0 .dropdown,
.p-0 .btn {
  padding: 0 !important;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}
</style>
